import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import SchoolPageTitle from "../basics/SchoolPageTitle";
import SchoolPageAvatar from "../basics/SchoolPageAvatar";
import { imageInsSlice } from "../../../redux/image/imageInsSlice";
import { ElementUploadImage } from "../../../features/base/image/ElementUploadImage";
import ElementSkeleton from "../../../features/base/ElementSkeleton";
import { ObjectTarget } from "../../../app/permissions";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { assertThumbnailUrl } from "../../../redux/common";
import { TopBar } from "../../../features/top/TopBar";

export function SchoolImage() {
    const school = useSelector(selectSchool);
    const dispatch = useAppDispatch();

    const {schoolId} = useParams();
    console.debug(`SchoolImage: ${schoolId}`);
    if(!schoolId) {
      return <ElementMissingContext />;
    }

    const breadcrumbTitle = "Alterar Imagem";
  
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const title = <SchoolPageTitle schoolId={schoolId} />;
    const pageAvatar = <SchoolPageAvatar />;
  
    const buildContent = () =>
      (school.selected)
      ? <ElementUploadImage 
            currentImage={assertThumbnailUrl(school.selected.url)}
            name={school.selected.name}
            backTo={`/school/${schoolId}`}
            target={{schoolId: schoolId, avatar: true, objectTarget: ObjectTarget.SCHOOL, targetId: schoolId}}
            backCleanup={() => {
              dispatch(schoolSlice.actions.clean());
              dispatch(imageInsSlice.actions.clean());
            }}
        />
      : <ElementSkeleton />;

    return <PageAuthenticatedLoading key="schoolImage"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
            states: [school.state], 
            content: buildContent,
            error: "Erro ao carregar escola",
            retry: () => {
            dispatch(schoolSlice.actions.clean());
            },
        }} />;
                
}
